import { isSnapPart } from '@lib/util/is-snap-part';
import { OriginalSource, SnapQuoteLineSource } from '@prisma/client';
import { Text, View } from '@react-pdf/renderer';
import { Nullish } from '@snap-types/types/nullish';

import { styles } from '../styles';

type PartIdProps = {
  partId: string;
  originalSource: OriginalSource;
  customerPartId: Nullish<string>;
  showCustomerPartId?: boolean;
  hideSnapPartId?: boolean;
  source?: Nullish<SnapQuoteLineSource>;
};

function PartIdText({ partId }: { partId: string }) {
  return <Text style={[styles.bold, { paddingBottom: '4px' }]}>{partId}</Text>;
}

function CustomerPartIdText({ customerPartId }: { customerPartId: string }) {
  return (
    <Text style={{ paddingBottom: '4px' }}>
      Customer Part: <Text style={[styles.bold]}>{customerPartId}</Text>
    </Text>
  );
}

export function PartId({
  partId,
  originalSource,
  customerPartId,
  showCustomerPartId,
  hideSnapPartId,
  source,
}: PartIdProps) {
  const isImported = source === SnapQuoteLineSource.IMPORT;
  const isPartIdSnapGenerated = partId.indexOf('snap-') === 0;

  if (isSnapPart(originalSource)) {
    if (hideSnapPartId) {
      return null;
    }

    if (isImported || customerPartId) {
      return (
        <View>
          {isImported && !isPartIdSnapGenerated && (
            <PartIdText partId={partId} />
          )}
          {customerPartId && (
            <CustomerPartIdText customerPartId={customerPartId} />
          )}
        </View>
      );
    }

    return null;
  }

  if (customerPartId && showCustomerPartId) {
    return (
      <View>
        <PartIdText partId={partId} />
        <CustomerPartIdText customerPartId={customerPartId} />
      </View>
    );
  }

  return <PartIdText partId={partId} />;
}
